import { Star, StarFilled } from "@carbon/icons-react";
import { useIsAdmin } from "component/admin";
import { ActionsOverlayAction } from "component/actions-overlay";
import { CommentConfig } from "component/comment";
import { useGlobalProperty } from "util/datastore";
import { Feature, t } from "util/stdtypes";

export const ActionPinComment : ActionsOverlayAction<{commentKey: string}> = {
    label: t('Feature'),
    icon: Star,
    action: async ({datastore, commentKey}) => {
        const pins = datastore.getGlobalProperty('pinned_comments') ?? {};
        const newPins = {...pins, [commentKey]: true};
        datastore.setGlobalProperty('pinned_comments', newPins);
        await datastore.callServerAsync('derivedviews', 'runTriggers', {
            type: 'comment', key: commentKey
        });
    }
}

export const ActionUnpinComment : ActionsOverlayAction<{commentKey: string}> = {
    label: t('Featured'),
    icon: StarFilled,
    action: async ({datastore, commentKey}) => {
        const pins = datastore.getGlobalProperty('pinned_comments') ?? {};
        const newPins = {...pins, [commentKey]: null};
        datastore.setGlobalProperty('pinned_comments', newPins);
        await datastore.callServerAsync('derivedviews', 'runTriggers', {
            type: 'comment', key: commentKey
        });
    }
}

function PinCommentAction({commentKey}: {commentKey: string}) {
    const pins = useGlobalProperty('pinned_comments');
    const isAdmin = useIsAdmin();
    if (!isAdmin) return [];

    const isPinned = pins?.[commentKey];
    return isPinned ? [ActionUnpinComment] : [ActionPinComment];
}

export const PinCommentFeature: Feature<CommentConfig, {}> = {
    name: "Pin Comment in Teaser",
    key: "pin_comment",
    providesConfig: {
        commentAdminActions: PinCommentAction,
    },
};
